var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
import API_service from "@iscr/xAppLib/providers/API_service";
export const useGetPaymentProfile = ({ doc_id, details, docpayAccount, }) => useAsync(() => __awaiter(void 0, void 0, void 0, function* () {
    return doc_id
        ? yield API_service.load_data(`docpay/profiles?doc_id=${encodeURIComponent(doc_id)}${details ? `&show_details=true` : ""}${docpayAccount ? `&docpay_account=${docpayAccount}` : ""}`)
        : undefined;
}), [doc_id, details, docpayAccount]);
